import styled from "styled-components";
import { NavLink as Link } from 'react-router-dom';



export const Component = styled(Link)`
`;